import { get } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getHeaderNavigationLinks = async (
  token: string,
  baseUrl: string,
  params = {},
  config?: any
) => {
  try {
    const queryPath = `${baseUrl}/navigation_links`;

    const res = await get(token, queryPath, params, config);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};

export const getFooterNavigationLinks = async (
  token: string,
  baseUrl: string,
  params = {},
  config?: any
) => {
  try {
    const queryPath = `${baseUrl}/navigation_links`;

    const res = await get(token, queryPath, params, config);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
